import { germanConfig, germanConfigRules } from './german';
import { englishConfig, englishConfigRules } from './english';
import { russianConfig, russianConfigRules } from './russian';
import { ClockConfigType, ConfigRulesProps } from './config.types';

/**
 * Unified structure for all configuration data
 */
export interface ConfigData {
  /** Letter configuration for the grid */
  config: string[];
  /** Rules for displaying the time */
  rules: ConfigRulesProps;
  /** Display name for UI elements */
  displayName: string;
}

export const CONFIGS: Record<ClockConfigType, ConfigData> = {
  german: {
    config: germanConfig,
    rules: germanConfigRules,
    displayName: 'German',
  },
  english: {
    config: englishConfig,
    rules: englishConfigRules,
    displayName: 'English',
  },
  russian: {
    config: russianConfig,
    rules: russianConfigRules,
    displayName: 'Russian',
  },
};

export const CONFIG_MAP = Object.fromEntries(
  Object.entries(CONFIGS).map(([key, value]) => [key, value.config])
);

export const CONFIG_RULES_MAP = Object.fromEntries(
  Object.entries(CONFIGS).map(([key, value]) => [key, value.rules])
);

export const CONFIG_DISPLAY_NAMES = Object.fromEntries(
  Object.entries(CONFIGS).map(([key, value]) => [key, value.displayName])
);
